import { useCssVars as _useCssVars, unref as _unref, defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sr-only" }


export default /*@__PURE__*/_defineComponent({
  __name: 'Switch',
  props: {
    modelValue: { type: Boolean },
    accentColor: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

_useCssVars(_ctx => ({
  "d5fb6baa": (_ctx.accentColor)
}))

const props = __props;

const emit = __emit;

const toggle = () => {
    emit("update:modelValue", !props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    type: "button",
    onClick: toggle,
    class: _normalizeClass(["flex w-8 flex-none cursor-pointer rounded-full p-px ring-1 ring-inset ring-gray-900/5 transition-colors duration-200 ease-in-out focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600", [_ctx.modelValue ? '' : 'bg-gray-200']]),
    style: _normalizeStyle(_ctx.modelValue ? { backgroundColor: _ctx.accentColor } : {})
  }, [
    _createElementVNode("span", _hoisted_1, [
      _renderSlot(_ctx.$slots, "default", {}, () => [
        _cache[0] || (_cache[0] = _createTextVNode("Toggle"))
      ])
    ]),
    _createElementVNode("span", {
      "aria-hidden": "true",
      class: _normalizeClass(["size-4 transform rounded-full bg-white shadow-sm ring-1 ring-gray-900/5 transition duration-200 ease-in-out", [_ctx.modelValue ? 'translate-x-3.5' : 'translate-x-0']])
    }, null, 2)
  ], 6))
}
}

})